import {useEffect, useState} from "react";
import {BoxService} from "../box-service";
import {ServiceLocator} from "../service-locator";

export const useBoxService = () => {
	const [value, setValue] = useState<BoxService>(ServiceLocator.boxService);

	useEffect(() => {
		console.log('use-box-service effect executed')
	}, []);

	return value;
}
